import { PureComponent } from '../../../../dispatcher/modules';
import {
  PUZZLE_INPUT_WITH_COPY,
  PUZZLE_INPUT_WITH_COPY_STATE
} from './Types';
import React from 'react';
import PuzzleCopyButton from '../../button/copy/PuzzleCopyButton';
import PuzzlePasswordInput from './PuzzlePasswordInput';
import HBox from '../../../layout/container/h_box/HBox';
import {
  BUTTON_SIZE_PROP
} from '../../button/Types';

/**
 * PuzzleInputWithCopy component renders an input field with an option to copy its value and toggle password visibility.
 * It can display an icon for toggling password visibility on the inside, and copy button either inside or outside the input field.
 * @param {object} inputProps - The props for the input field.
 * @param {object} copyButtonProps - The props for the copy button.
 */
class PuzzleInputWithCopy extends PureComponent<PUZZLE_INPUT_WITH_COPY, PUZZLE_INPUT_WITH_COPY_STATE> {
  state:PUZZLE_INPUT_WITH_COPY_STATE = {
    showPassword: false
  }

  /**
   * Toggles the visibility of the password in the input field.
   * @returns {void}
   */
 private togglePasswordVisibility = () => {
   const { showPassword } = this.state;
   this.setState({ showPassword: !showPassword });
 };

 render() {
   const { showPassword } = this.state;
   const {
     inputProps,
     copyButtonProps,
     copyButtonPosition
   } = this.props;
   const { value } = inputProps;
   const cssClass = copyButtonPosition === 'inside' ? 'inside' : 'outside';

   // Combine inputProps and copyButtonProps
   const inputWithCopyProps = {
     ...inputProps,
     copyButtonPosition,
     copyButtonProps: { ...copyButtonProps }
   };

   const passwordInputProps = inputWithCopyProps || this.props;

   // Dynamically set input type based on showPassword state
   const inputType = showPassword ? 'text' : inputProps.inputType;

   const showCopyInside = copyButtonPosition === 'inside';
   const showCopyOutside = copyButtonPosition === 'outside';
   let btnSize: BUTTON_SIZE_PROP = 'small';
   if (inputProps.fieldSize === 'large') {
     btnSize = 'medium';
   }
   return (
     <HBox className={cssClass} gap={3} alignItemsCenter>
       <PuzzlePasswordInput
         {...passwordInputProps}
         showCopy={showCopyInside}
         inputType={inputType}
         togglePasswordVisibility={this.togglePasswordVisibility}
       />
       {showCopyOutside &&
       <PuzzleCopyButton
         {...copyButtonProps}
         className={'tp-copy-password-btn'}
         size={btnSize}
         extraSmall={this.props.inputProps?.fieldSize === 'small'}
         copyButtonPosition={copyButtonPosition}
         reverse
         inputValue={value}
       />}
     </HBox>
   );
 }
}

export default PuzzleInputWithCopy;

